import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.settings.title',
    defaultMessage: 'Settings',
    description: 'title of the settings page',
  },
  subNavigation: {
    general: {
      id: 'pages.settings.subNavigation.general',
      defaultMessage: 'General',
      description: 'label of the general tab on the settings page',
    },
    fulfilmentLocations: {
      id: 'pages.settings.subNavigation.fulfilmentLocations',
      defaultMessage: 'Fulfilment locations',
      description: 'label of the fulfilment locations tab on the settings page',
    },
    shippingMethods: {
      id: 'pages.settings.subNavigation.shippingMethods',
      defaultMessage: 'Shipping methods',
      description: 'label of the shipping methods tab on the settings page',
    },
  },
  createFulfilmentLocation: {
    button: {
      id: 'pages.settings.createFulfilmentLocation.button',
      defaultMessage: 'Create location',
      description:
        'label of the create button on the fulfilment locations tab on the settings page',
    },
  },
};

export default defineMessages(translations);
